import { sellerConstants } from '../../../_constants/seller.constants';
import { sellerAdminService } from '../../../_services';

export const RemoveSellerAdminAction = {
    removeSellerAdmin
};

function removeSellerAdmin(data) {

    return dispatch => {
        dispatch(request());
        sellerAdminService.removeSellerAdmin(data)
            .then(
                response => {
                    dispatch(success(response));
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: sellerConstants.REQUEST_REMOVE_SELLER_ADMIN } }
    function success(data) { return { type: sellerConstants.REMOVE_SELLER_ADMIN_SUCCESS, data } }
    function failure(error) { return { type: sellerConstants.REMOVE_SELLER_ADMIN_ERROR, error } }
}



// WEBPACK FOOTER //
// ./src/_actions/sellers/sellerAdmin/removeSellerAdmin.actions.js